<template>
  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title class="headline d-flex align-center">
        <v-icon size="32" :color="dialogColor" class="mr-2">
          {{ dialogIcon }}
        </v-icon>
        {{ dialogTitle }}
      </v-card-title>

      <v-card-text class="text-subtitle-1">
        <p>{{ dialogMessage }}</p>
        <v-textarea
          v-if="isRejection"
          v-model="rejectionReason"
          label="Rejection Reason"
          outlined
          dense
        ></v-textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn color="grey" variant="text" @click="closeDialog">
          <v-icon left>mdi-close</v-icon> Cancel
        </v-btn>
        <v-btn :color="dialogColor" variant="elevated" @click="confirmAction">
          <v-icon left>mdi-check</v-icon> Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: String,
    message: String,
    icon: String,
    color: String,
    isRejection: Boolean, // Flag to check if it’s a rejection
  },
  data() {
    return {
      rejectionReason: "",
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    dialogTitle() {
      return this.title || "Confirm Action";
    },
    dialogMessage() {
      return this.message || "Are you sure you want to proceed?";
    },
    dialogIcon() {
      return this.icon || "mdi-help-circle-outline";
    },
    dialogColor() {
      return this.color || "blue";
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:show", false);
    },
    confirmAction() {
      this.$emit("confirm", this.rejectionReason);
      this.closeDialog();
    },
  },
};
</script>
